<ion-content class="work-order">
    <ng-container>
        <app-header [isParentPage]="false" [title]="'Work Order Report'"></app-header>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row class="ion-align-items-start ion-wrap">
                        <ion-col size="12" [sizeMd]="authService.user?.isCostCenterUser? 4:5" >
                            <ion-input
                                type="text" 
                                [(ngModel)]="lastName" 
                                class="ion-text-left color-light" 
                                [placeholder]="
                                'Enter part or all of last name, or leave blank for all'
                                "  (keydown.enter)="onEnterKey($event)"
                                >
                            </ion-input>

                            </ion-col>
                            <ion-col size="12" size-md="2" *ngIf="!authService.user?.isCostCenterUser">
                                <ion-button 
                                color="gallaghergreen" 
                                class="btn-box-shadow " 
                                (click)="getDataByLastName()">
                                <span>Show</span>
                            </ion-button>
                            </ion-col>
                 <ion-col size="12" size-md="2" *ngIf="authService.user?.isCostCenterUser">
                    <ng-select 
                        placeholder="Select Cost Center" 
                        class="select ion-margin-bottom" 
                        (change)="changeCostCenter($event)"
                        (keydown.enter)="onEnterKey($event)">
                        <ng-option 
                            *ngFor="let costCenter of loginDepts" 
                            [value]="costCenter.departmentCode">
                            {{ costCenter.departmentCode }}
                        </ng-option>
                    </ng-select>
                    
                 </ion-col>
                <ion-col size="12" size-md="auto" *ngIf="authService.user?.isCostCenterUser">
                    <ion-button 
                    color="gallaghergreen" 
                    class="btn-box-shadow" 
                    (click)="getDataCostCenter()">
                    <span>Show</span>
                    </ion-button>
                </ion-col >
                <ion-col size="12" size-md="2.4" 
                 *ngIf="authService.user?.isCostCenterUser">
                    <a 
                    style="color:white; text-decoration: underline; cursor: pointer;padding-top:20px;"
                    class="text-link"
                    (click)="GetRecentWorkOrder()">
                    View Recent Work Orders
                    </a>
                </ion-col>
  
                </ion-row>
                </ion-grid>
            </ion-row>
            <div class="page-loader" style="padding-top:15%" *ngIf="!loaded">
                <ion-spinner></ion-spinner>
            </div>
              <ion-row justify-content-center>
                <ion-col size="12" class="center-text">
                    <p>Click Employee ID to see that employee for 2.0 years.</p>
                    <p>Click Department ID to see that department for last 2 weeks.</p>
                    <p style="margin-bottom: 1px;">Click for printer friendly version.</p>
                </ion-col>
             </ion-row>
            <ion-row >
                <div *ngIf="!authService.user?.isWearer && !authService.user?.isCostCenterUser" class="ion-padding table-container">
                    <app-report-table [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements"></app-report-table>
                </div>
                <div *ngIf="authService.user?.isCostCenterUser" class="ion-padding table-container">
                    <app-cost-center-report-table  [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize"  [totalElements]="totalElements" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" (stopCodeClicked)="onStopCodeFilter($event)" (costCenterClicked)="onCostCenterFilter($event)"  [pageType]="authService.user?.isCostCenterUser ? 'workOrder' : ''" ></app-cost-center-report-table>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>